import { get } from 'lodash'

export default function () {
  this.reset.token = get(this.$route, 'query.token', null)
}



// WEBPACK FOOTER //
// ./src/app/auth/reset/resources/mounted.js